var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.actions),function(action){return _c('data-list-action',{key:action.handle,ref:"actions",refInFor:true,attrs:{"action":action,"selections":1},on:{"selected":_vm.run}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }